module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-profil"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(!_vm.fetchError) ? _c('div', [_c('div', {
    staticClass: "top-page"
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h1', [_vm._v("\n                            User\n                            "), _c('small', [_vm._v("• #" + _vm._s(_vm.user.id.value) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto cc-right"
  }, [_c('router-link', {
    staticClass: "btn cc-bg-green fa-angle-left",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Back to users")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "boxed"
  }, [_c('pre', [_vm._v(_vm._s(_vm.user))])])])]) : _c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n            " + _vm._s(_vm.fetchError) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ab5d076!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/persons/users/user-profile.vue
// module id = 218
// module chunks = 0